/**
 * Build 1–2 letter initials from a review / feedback display name (avatar placeholder).
 * Empty or whitespace-only → "?".
 *
 * @param {string | null | undefined} name
 * @returns {string}
 */
export function feedbackInitials(name) {
  const raw = typeof name === 'string' ? name.trim() : ''
  if (!raw) {
    return '?'
  }
  const words = raw.split(/\s+/).filter(Boolean)
  if (words.length >= 2) {
    const a = words[0].charAt(0)
    const b = words[1].charAt(0)
    return (a + b).toUpperCase()
  }
  const w = words[0]
  if (w.length >= 2) {
    return w.slice(0, 2).toUpperCase()
  }
  return w.charAt(0).toUpperCase()
}
